import styled from '@emotion/styled';
import { rem } from '@utils';

const Actions = styled.div`
  display: flex;
  gap: ${rem(24)} ${rem(8)};
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    width: 100%;

    .button {
      width: 100%;
    }

    .button:first-of-type {
      order: 2;
    }
  }
`;

const CheckboxWrapper = styled.div`
  && * {
    font-weight: 600;
  }

  @media (max-width: 768px) {
    margin-bottom: ${rem(50)};
    width: 100%;
  }
`;

const Content = styled.div`
  font-size: ${rem(14)};
  line-height: ${rem(16)};
  padding: ${rem(16)} 0 ${rem(74)};

  @media (max-width: 768px) {
    padding-bottom: ${rem(8)};
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export default {
  Actions,
  CheckboxWrapper,
  Content,
  Footer
};
